import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as deviceDocumentsServiceClear } from './deviceDocumentsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'deviceDocuments',
  serviceTableName: 'deviceDocumentsService',
  serviceClearFunction: deviceDocumentsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.deviceDocuments]),
});
